"use strict";

define('libs/paste.handler',['underscore', 'backbone'], function (_, Backbone) {
  var PASTE_ID = 0;
  function PasteHandler(element, options) {
    this.$element = $(element);
    this.element = this.$element.get(0);
    this.options = _.extend({
      single: true
    }, options);
    this.pasteId = ++PASTE_ID;
    this.bindEvents();
  }
  ;
  _.extend(PasteHandler.prototype, Backbone.Events, {
    bindEvents: function bindEvents() {
      var $el = this.$element,
        self = this;
      $el.on('paste.pasteHandler' + this.pasteId, _.bind(this.onPaste, this));
      $(document).on('paste.pasteHandler' + this.pasteId, _.bind(this.onPaste, this));
    },
    onPaste: function onPaste(ev) {
      var clipboard = ev.originalEvent.clipboardData,
        items = [],
        files = [],
        foundImage = false;
      if (ev.originalEvent === this._previousEvent) {
        return;
      }
      if (ev.target !== this.element) {
        return;
      }
      if (clipboard) {
        items = clipboard.items || [];
      }
      if (clipboard) {
        files = clipboard.files || [];
      }
      for (var i = 0, item, file; i < items.length; i++) {
        item = items[i];
        if (item.type.indexOf('image') !== -1) {
          file = item.getAsFile();
          file.name = 'filename';
          this.trigger('paste:image', file);
          foundImage = true;
          if (this.options.single) {
            break;
          }
        }
      }
      ;
      if (foundImage && this.options.single) {
        files = [];
      }
      for (var i = 0, file; i < files.length; i++) {
        file = files[i];
        if (file.type.indexOf('image') !== -1) {
          file.name = 'filename';
          this.trigger('paste:image', file);
          foundImage = true;
          if (this.options.single) {
            break;
          }
        }
      }
      if (foundImage) {
        this._previousEvent = ev.originalEvent;
      } else {
        this.trigger('paste:error');
      }
    },
    destroy: function destroy() {
      this.trigger('destroy');
      $(document).off('paste.pasteHandler' + this.pasteId);
      this.$element.off('paste.pasteHandler' + this.pasteId);
      this.stopListening().off();
      return this;
    }
  });
  return PasteHandler;
});

